import type { User } from '@supabase/supabase-js';
import { supabase } from '../config/supabase';
import type { UserRole } from '../types/user';

export async function resolveUserRole(user: User): Promise<UserRole | null> {
  const metaRole = user.user_metadata?.role as UserRole | undefined;
  if (metaRole === 'superadmin' || metaRole === 'user') {
    return metaRole;
  }

  const { data, error } = await supabase
    .from('users')
    .select('role')
    .eq('id', user.id)
    .maybeSingle();

  if (error || !data?.role) {
    return null;
  }

  return data.role as UserRole;
}

export function isSuperadmin(role: UserRole | null | undefined): boolean {
  return role === 'superadmin';
}
